// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"d2640b47","227":"d1deadd4","252":"a878c2dc","453":"7743f018","456":"fea2c9ad","500":"0f468d9b","583":"81271c09","648":"311a352e","754":"6ec85fee","795":"b18c8867","834":"777f4928","957":"b408815a","961":"22d98489"}[chunkId] + ".chunk.js";
};